import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MaintenanceLogo = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 654 405"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 654, height: 405, fill: 'none', ...props.sx }}
      data-testid="maintenanceLogo"
    >
      <rect width="654" height="405" fill="white" />
      <path
        d="M630.224 363.726L394.713 363.654L31.3334 363.548C31.3334 363.548 -11.0463 293.792 27.6308 199.538C52.8444 138.103 103.82 92.7719 191.331 120.491C209.358 126.2 237.552 122.554 273.804 98.9732C275.645 97.7743 277.478 96.5237 279.295 95.2238C280.287 94.5105 281.277 93.7855 282.259 93.0418C294.606 83.7199 306.152 71.9296 315.666 57.4224C321.123 49.1047 327.563 41.749 334.79 35.3295C339.296 31.3291 344.11 27.6923 349.186 24.4098C352.426 22.3145 355.769 20.3671 359.213 18.5604C368.365 13.7552 378.191 9.96354 388.47 7.15031C389.469 6.87814 390.471 6.61301 391.48 6.35726C393.823 5.76364 396.186 5.22164 398.569 4.72892C400.203 4.3887 401.845 4.0743 403.496 3.78101C405.516 3.42437 407.553 3.09588 409.597 2.81198H409.6C415.174 2.02362 420.827 1.49335 426.536 1.20945C427.617 1.15548 428.7 1.11325 429.788 1.07571C430.478 1.05459 431.171 1.03582 431.861 1.0194C433.984 0.972472 436.112 0.960742 438.243 0.984205C491.407 1.51447 547.029 23.1287 580.902 62.0423C597.953 81.6363 609.497 105.611 612.425 133.487C613.506 143.778 613.417 154.607 611.999 165.939C611.958 166.284 611.915 166.627 611.867 166.965C611.795 167.514 611.718 168.067 611.637 168.619C611.347 170.698 611.004 172.795 610.616 174.912C609.758 179.604 609.175 184.527 607.354 189.236C569.684 286.709 678.161 278.055 630.224 363.726Z"
        fill="#E3E5EE"
      />
      <path
        d="M292.058 351.133H281.943C279.381 351.133 277.303 349.099 277.303 346.59V246.145C277.303 243.637 279.381 241.602 281.943 241.602H292.058C294.62 241.602 296.698 243.637 296.698 246.145V346.59C296.698 349.099 294.62 351.133 292.058 351.133Z"
        fill="white"
      />
      <path
        d="M318.496 351.133H308.381C305.819 351.133 303.741 349.099 303.741 346.591V246.145C303.741 243.637 305.819 241.603 308.381 241.603H318.496C321.058 241.603 323.136 243.637 323.136 246.145V346.591C323.136 349.099 321.058 351.133 318.496 351.133Z"
        fill="white"
      />
      <path
        d="M344.932 351.133H334.814C332.252 351.133 330.175 349.099 330.175 346.591V246.145C330.175 243.637 332.252 241.603 334.814 241.603H344.932C347.494 241.603 349.572 243.637 349.572 246.145V346.591C349.574 349.099 347.496 351.133 344.932 351.133Z"
        fill="white"
      />
      <path
        d="M371.37 351.133H361.255C358.693 351.133 356.615 349.099 356.615 346.591V246.145C356.615 243.637 358.693 241.603 361.255 241.603H371.37C373.932 241.603 376.01 243.637 376.01 246.145V346.591C376.01 349.099 373.932 351.133 371.37 351.133Z"
        fill="white"
      />
      <path
        d="M397.809 351.133H387.693C385.131 351.133 383.053 349.099 383.053 346.591V246.145C383.053 243.637 385.131 241.603 387.693 241.603H397.809C400.373 241.603 402.448 243.637 402.448 246.145V346.591C402.448 349.099 400.371 351.133 397.809 351.133Z"
        fill="white"
      />
      <path
        d="M424.244 351.133H414.126C411.565 351.133 409.487 349.099 409.487 346.591V246.145C409.487 243.637 411.565 241.603 414.126 241.603H424.244C426.806 241.603 428.884 243.637 428.884 246.145V346.591C428.886 349.099 426.809 351.133 424.244 351.133Z"
        fill="white"
      />
      <path
        d="M431.856 1.01923V220.01H279.292V95.2236C280.285 94.5104 281.274 93.7854 282.257 93.0416C294.604 83.7197 306.15 71.9295 315.664 57.4222C321.121 49.1045 327.56 41.7488 334.788 35.3293C339.294 31.3289 344.108 27.6921 349.184 24.4096C352.424 22.3144 355.767 20.3669 359.211 18.5603C368.363 13.755 378.189 9.96337 388.468 7.15014C389.467 6.87797 390.469 6.61283 391.478 6.35709C393.821 5.76347 396.184 5.22147 398.566 4.72874C400.201 4.38853 401.842 4.07412 403.494 3.78084C405.514 3.4242 407.551 3.09571 409.595 2.81181H409.597C415.172 2.02345 420.825 1.49318 426.534 1.20928C427.614 1.15531 428.698 1.11308 429.786 1.07554C430.473 1.05208 431.166 1.0333 431.856 1.01923Z"
        fill="white"
      />
      <path
        d="M431.856 1.0192C431.166 1.03328 430.473 1.05205 429.783 1.07552V216.505H282.259V93.0416C281.277 93.7854 280.287 94.5104 279.295 95.2236C277.478 96.5235 275.645 97.7741 273.804 98.9731V225.355H438.24V0.981662C436.108 0.960545 433.979 0.972278 431.856 1.0192Z"
        fill="#ABAFBF"
      />
      <path
        d="M447.405 225.803H265.203V222.23C265.203 219.672 267.322 217.596 269.934 217.596H442.784C445.334 217.596 447.402 219.621 447.402 222.117V225.803H447.405Z"
        fill="#ABAFBF"
      />
      <path
        d="M359.211 18.5602V219.245H349.184V24.4095C352.424 22.3143 355.77 20.3645 359.211 18.5602Z"
        fill="#ABAFBF"
      />
      <path
        d="M355.839 118.039H355.034C354.492 118.039 354.046 117.612 354.03 117.073L353.675 105.791C353.658 105.228 354.111 104.764 354.679 104.764H356.225C356.793 104.764 357.248 105.231 357.229 105.794L356.846 117.075C356.824 117.615 356.381 118.039 355.839 118.039Z"
        fill="#878C9D"
      />
      <path
        d="M416.638 113.628L429.826 115.39L416.142 216.568L402.954 214.806L416.638 113.628Z"
        fill="#FFEC85"
      />
      <path
        d="M416.384 214.777L416.142 216.568L402.954 214.808L403.196 213.018L416.384 214.777Z"
        fill="#FFC425"
      />
      <path
        d="M429.949 114.494L429.707 116.284L416.519 114.524L416.761 112.734L429.949 114.494Z"
        fill="#FFC425"
      />
      <path
        d="M410.4 209.376C409.092 209.2 408.172 208.003 408.347 206.704C408.521 205.401 409.727 204.489 411.038 204.665C412.346 204.841 413.267 206.035 413.092 207.337C412.917 208.639 411.711 209.552 410.4 209.376Z"
        fill="#FFC425"
      />
      <path
        d="M421.625 126.392C420.317 126.216 419.397 125.022 419.572 123.719C419.747 122.417 420.952 121.504 422.263 121.68C423.571 121.856 424.492 123.053 424.317 124.353C424.139 125.655 422.936 126.568 421.625 126.392Z"
        fill="#FFC425"
      />
      <path
        d="M410.647 157.936C413.552 158.893 415.452 161.793 415.03 164.916C414.609 168.037 412.004 170.336 408.948 170.498L410.647 157.936Z"
        fill="#FFC425"
      />
      <path
        d="M368.73 216.558H331.788C330.093 216.558 328.722 215.213 328.722 213.554V213.51C328.722 211.851 330.096 210.506 331.788 210.506H368.73C370.424 210.506 371.797 211.851 371.797 213.51V213.554C371.795 215.213 370.422 216.558 368.73 216.558Z"
        fill="#EBA62F"
      />
      <path
        d="M299.413 216.553H340.597C342.884 216.553 344.753 214.723 344.753 212.484V181.696C344.753 179.46 342.884 177.627 340.597 177.627H299.413C297.127 177.627 295.258 179.457 295.258 181.696V212.486C295.26 214.723 297.129 216.553 299.413 216.553Z"
        fill="#EBA62F"
      />
      <path
        d="M333.925 177.799C333.925 177.799 323.673 171.405 313.859 171.335C307.468 171.288 300.187 177.527 299.749 177.595C298.639 177.766 303.451 177.822 303.451 177.822C303.451 177.822 310.665 173.653 313.905 173.554C317.813 173.435 327.754 178.165 327.754 178.165L333.925 177.799Z"
        fill="#FFC425"
      />
      <path
        d="M294.604 216.553H335.787C338.074 216.553 339.943 214.723 339.943 212.484V181.696C339.943 179.46 338.074 177.627 335.787 177.627H294.604C292.317 177.627 290.448 179.457 290.448 181.696V212.486C290.448 214.723 292.317 216.553 294.604 216.553Z"
        fill="#FFC425"
      />
      <path
        d="M465.721 281.002H410.582V277.619H465.721C471.532 277.619 476.258 272.989 476.258 267.302V5.32458H479.714V267.302C479.717 274.857 473.438 281.002 465.721 281.002Z"
        fill="white"
      />
      <path
        d="M451.244 278.999H447.788V361.298H451.244V278.999Z"
        fill="white"
      />
      <path
        d="M439.503 361.298H380.415L378.208 313.238H441.509L439.503 361.298Z"
        fill="#878C9D"
      />
      <path
        d="M441.78 315.099H376.995C376.475 315.099 376.053 314.686 376.053 314.176V313.89C376.053 313.381 376.475 312.968 376.995 312.968H441.78C442.3 312.968 442.722 313.381 442.722 313.89V314.176C442.722 314.688 442.3 315.099 441.78 315.099Z"
        fill="#ABAFBF"
      />
      <path
        d="M434.775 329.376H384.808V342.562H434.775V329.376Z"
        fill="#ABAFBF"
      />
      <path
        d="M475.094 361.297H424.278L422.38 300.457H476.817L475.094 361.297Z"
        fill="#FFC425"
      />
      <path
        d="M477.862 298.855H420.528V303.529H477.862V298.855Z"
        fill="#EBA62F"
      />
      <path
        d="M471.027 320.889H428.055V337.58H471.027V320.889Z"
        fill="#FFEC85"
      />
      <path
        d="M222.198 356.934L273.797 347.748V362.009H221.951C221.951 362.011 222.445 356.692 222.198 356.934Z"
        fill="#FFC425"
      />
      <path
        d="M308.856 347.75H273.797V362.011H308.856V347.75Z"
        fill="#EBA62F"
      />
      <path
        d="M652.126 364.233H1.69844C1.18799 364.233 0.770996 363.825 0.770996 363.325V362.473C0.770996 361.974 1.18799 361.565 1.69844 361.565H652.126C652.636 361.565 653.053 361.974 653.053 362.473V363.325C653.053 363.825 652.636 364.233 652.126 364.233Z"
        fill="#373B49"
      />
      <path
        d="M390.167 338.05C387.188 351.14 377.055 361.6 367.534 361.417C358.013 361.232 352.707 350.474 355.686 337.384C358.664 324.294 368.797 313.834 378.318 314.017C387.839 314.202 393.145 324.962 390.167 338.05Z"
        fill="#676C7D"
      />
      <path
        d="M388.026 337.569C385.047 350.659 374.915 361.119 365.394 360.936C355.872 360.753 350.567 349.993 353.545 336.903C356.522 323.813 366.657 313.353 376.178 313.536C385.699 313.719 391.005 324.479 388.026 337.569Z"
        fill="#ABAFBF"
      />
      <path
        d="M366.312 357.508C366.24 357.508 366.17 357.508 366.098 357.505C363.041 357.447 360.39 356.126 358.432 353.688C355.309 349.798 354.351 343.5 355.865 336.842C358.415 325.633 367.136 316.63 375.308 316.799C378.366 316.858 381.017 318.179 382.975 320.617C386.097 324.507 387.056 330.804 385.541 337.463C383.015 348.575 374.422 357.508 366.312 357.508ZM375.095 317.041C367.095 317.041 358.609 325.889 356.107 336.895C354.61 343.484 355.552 349.704 358.629 353.54C360.539 355.919 363.122 357.208 366.106 357.266C366.175 357.266 366.245 357.269 366.314 357.269C374.314 357.269 382.8 348.421 385.302 337.414C386.799 330.826 385.858 324.605 382.781 320.772C380.871 318.392 378.287 317.104 375.303 317.046C375.234 317.041 375.164 317.041 375.095 317.041Z"
        fill="#676C7D"
      />
      <path
        d="M253.093 288.749C252.631 288.548 252.419 288.008 252.623 287.546L256.68 278.276C257 277.543 256.665 276.686 255.932 276.366L235.524 267.438C233.87 266.713 233.111 264.777 233.836 263.123L236.889 256.139C237.615 254.484 239.55 253.725 241.205 254.451L249.675 258.157C250.137 258.358 250.349 258.898 250.145 259.36C249.941 259.822 249.404 260.033 248.943 259.829L240.472 256.123C239.739 255.803 238.882 256.139 238.562 256.872L235.509 263.856C235.189 264.589 235.524 265.446 236.257 265.766L256.665 274.693C258.319 275.418 259.078 277.354 258.353 279.008L254.298 288.279C254.092 288.741 253.555 288.95 253.093 288.749Z"
        fill="#ABAFBF"
      />
      <path
        d="M252.582 292.257L250.507 291.348C249.731 291.008 249.374 290.097 249.712 289.32L254.327 278.769C254.668 277.992 255.579 277.636 256.356 277.974L258.431 278.882C259.208 279.223 259.564 280.134 259.226 280.911L254.611 291.462C254.27 292.239 253.359 292.595 252.582 292.257Z"
        fill="#FFEC85"
      />
      <path
        d="M284.798 270.61L281.928 277.171C281.179 278.88 279.189 279.656 277.478 278.91L243.518 264.054C241.812 263.309 241.03 261.319 241.778 259.607L244.648 253.047C245.397 251.338 247.387 250.561 249.095 251.307L283.056 266.163C284.764 266.909 285.546 268.902 284.798 270.61Z"
        fill="#ABAFBF"
      />
      <path
        d="M284.798 270.61L283.81 272.868C283.061 274.577 281.071 275.354 279.36 274.608L245.4 259.752C243.694 259.006 242.912 257.016 243.66 255.305L244.649 253.047C245.397 251.338 247.387 250.561 249.096 251.307L283.056 266.163C284.765 266.909 285.547 268.902 284.798 270.61Z"
        fill="white"
      />
      <path
        d="M191.997 297.185C191.997 297.185 199.381 298.256 201.095 300.182C202.806 302.107 203.877 303.607 202.806 304.464C201.735 305.32 185.467 301.147 185.467 301.147L191.997 297.185Z"
        fill="#ABAFBF"
      />
      <path
        d="M174.229 271.071L194.136 296.543C194.136 296.543 192.425 299.968 186.858 300.61C181.293 301.253 169.519 297.614 169.519 296.543C169.519 295.471 174.229 271.071 174.229 271.071Z"
        fill="#FFEC85"
      />
      <path
        d="M237.239 326.247C231.449 332.919 219.239 337.231 195.682 338.323C193.791 338.413 191.888 338.486 189.976 338.542C188.007 338.602 186.037 338.646 184.065 338.672C177.662 338.759 171.292 338.687 165.222 338.483C159.337 338.282 153.731 337.959 148.652 337.536C138.718 336.71 130.787 335.507 126.691 334.129C125.465 333.719 124.582 333.29 124.089 332.851C123.668 332.477 123.328 332.036 123.072 331.535C121.586 328.779 122.362 324.265 124.156 319.286C126.773 312.041 131.576 303.826 134.81 298.685C135.458 297.657 136.036 296.759 136.529 296.008C137.515 294.498 138.129 293.616 138.129 293.616C138.129 293.616 149.132 294.638 164.197 296.589C167.269 296.984 170.515 297.425 173.868 297.9C206.257 302.481 238.532 310.715 238.501 321.637C238.495 323.304 238.604 324.675 237.239 326.247Z"
        fill="#FFC425"
      />
      <path
        d="M197.133 338.192C195.164 338.251 186.037 338.646 184.065 338.672C177.662 338.76 171.292 338.687 165.222 338.483L159.513 315.482C168.345 327.798 194.296 337.397 197.133 338.192Z"
        fill="#EBA62F"
      />
      <path
        d="M178.054 405H209.454C208.959 403.805 207.764 402.246 204.85 401.735C199.905 400.868 191.318 398.191 192.42 391.055C193.535 383.821 181.492 382.886 181.492 382.886C181.492 382.886 176.477 402.246 178.054 405Z"
        fill="#373B49"
      />
      <path
        d="M237.75 325.065C237.75 325.065 198.798 386.345 195.559 393.626C195.559 393.626 182.305 394.859 179.118 385.393C179.118 385.393 202.272 320.724 212.449 315.394C222.623 310.064 237.75 325.065 237.75 325.065Z"
        fill="#FFC425"
      />
      <path
        d="M159.198 196.051C159.198 196.051 172.611 214.41 184.566 215.39C184.566 215.39 183.038 208.481 179.51 204.124C180.457 202.594 181.283 201.195 181.991 199.946C184.339 195.785 185.379 193.297 185.379 193.297L179.879 183.348L178.744 178C177.815 180.511 176.725 182.829 175.51 184.739C169.248 194.575 159.198 196.051 159.198 196.051Z"
        fill="#ABAFBF"
      />
      <path
        d="M174.988 184.64C174.988 184.64 173.042 193.836 181.991 199.946C184.339 195.785 185.379 193.297 185.379 193.297L179.879 183.347C175.486 182.697 174.988 184.64 174.988 184.64Z"
        fill="#878C9D"
      />
      <path
        d="M187.054 198.843C187.054 198.843 170.229 189.678 176.098 179.287C181.967 168.897 183.748 160.717 194.74 166.13C205.733 171.542 205.56 176.676 204.445 180.622C203.327 184.566 191.581 200.96 187.054 198.843Z"
        fill="#ABAFBF"
      />
      <path
        d="M176.157 158.601C176.065 158.34 175.737 158.033 174.893 157.651C174.893 157.651 175.752 157.478 176.684 157.814C177.334 156.665 178.808 154.753 181.077 155.026C181.077 155.026 179.735 155.199 179.089 156.438C182.447 154.866 188.278 155.032 202.039 161.654C220.176 170.383 209.307 180.17 206.324 180.686C203.34 181.2 198.777 174.869 194.124 173.488C189.468 172.107 186.05 178.402 184.169 178.72C182.287 179.037 183.508 177.662 181.805 175.912C180.101 174.159 178.555 177.571 178.279 180.07C178.003 182.568 174 184.457 174 184.457C174 184.457 174 184.457 172.338 180.199C170.676 175.94 173.112 161.564 175.52 159.228C175.729 159.022 175.941 158.81 176.157 158.601Z"
        fill="#373B49"
      />
      <path
        d="M75.6986 384.966C75.6986 384.966 71.7858 390.905 70.8748 392.83C69.9637 394.756 71.7497 398.852 74.4339 399.466C76.8006 400.011 77.1542 404.207 77.1542 404.207H65.6793C64.4636 404.207 63.3693 403.539 62.9021 402.509C61.2839 398.947 60.9148 394.317 60.5896 392.768C59.9056 389.511 58.5506 386.778 59.1494 383.461C59.7456 380.155 65.3979 378.243 75.6986 378.274C87.0161 378.307 75.6986 384.966 75.6986 384.966Z"
        fill="#373B49"
      />
      <path
        d="M109.432 313.345C118.083 322.512 181.619 303.545 176.294 298.713C174.939 297.485 175.404 296.011 174.851 294.034C172.216 284.655 177.463 268.609 179.714 262.386C180.24 260.944 180.602 260.032 180.669 259.849C182.816 254.042 184.478 247.995 185.565 242.154C187.661 230.945 187.622 220.518 184.757 214.13C184.736 214.096 184.734 214.065 184.713 214.042C172.812 210.563 166.259 193.054 166.259 193.054C166.259 193.054 128.557 203.762 114.87 257.562C114.87 257.562 114.162 260.993 113.29 266.142H113.285C113.022 267.721 112.74 269.463 112.456 271.322C110.996 280.894 110.146 293.172 109.279 302.311C109.246 302.629 109.215 302.949 109.181 303.282C108.75 307.223 107.994 311.822 109.432 313.345Z"
        fill="#FFEC85"
      />
      <path
        d="M159.462 304.247C159.462 304.247 153.128 305.08 140.355 306.022C127.117 307.003 113.087 309.088 110.808 313.535C110.052 315.009 110.578 318.734 112.054 323.883C115.319 335.265 123.23 353.592 132.263 369.844C109.058 371.189 77.4901 376.31 77.4901 376.31C72.3256 382.148 74.4884 388.982 74.4884 388.982C76.1454 388.995 81.1241 389.7 87.9198 390.797C112.542 394.758 142.528 402.909 161.121 402.909C165.189 402.909 168.232 400.021 169.468 396.245V396.24C177.108 372.991 159.462 304.247 159.462 304.247Z"
        fill="#FFC425"
      />
      <path
        d="M112.054 325.612C124.863 325.207 156.986 309.437 156.462 309.311C150.479 307.839 145.129 306.82 140.357 306.177C127.119 307.243 113.089 309.514 110.81 314.351C110.051 315.957 110.578 320.011 112.054 325.612Z"
        fill="#EBA62F"
      />
      <path
        d="M153.182 229.817C153.182 229.817 153.928 288.09 174.852 294.034C172.216 284.655 177.464 268.609 179.714 262.386C174.32 247.401 164.391 232.282 153.182 229.817Z"
        fill="#FFEC85"
      />
      <path
        d="M159.934 195.676C159.934 195.676 176.049 199.028 177.624 213.151C178.77 223.437 167.524 246.727 167.524 246.727L165.382 244.585C165.382 244.585 175.254 215.828 173.734 210.934C171.788 204.663 162.522 195.278 154 199.026L159.934 195.676Z"
        fill="#FFC425"
      />
      <path
        d="M109.432 313.345C118.083 322.512 182.987 303.746 177.662 298.915C176.307 297.686 175.401 296.011 174.852 294.034C172.216 284.655 177.463 268.609 179.714 262.386C180.241 260.943 180.602 260.032 180.669 259.849L177.391 256.576L165.382 244.59C165.382 244.59 161.831 248.619 155.117 253.19C146.319 259.188 132.088 266.116 113.293 266.144H113.288C113.025 267.724 112.743 269.466 112.459 271.324C110.998 280.897 110.149 293.175 109.282 302.314C109.249 302.631 109.218 302.951 109.184 303.284C108.75 307.223 107.994 311.822 109.432 313.345Z"
        fill="#FFC425"
      />
      <path
        d="M155.115 253.188C157.518 270.127 162.886 290.632 174.852 294.034C172.216 284.655 177.464 268.609 179.714 262.386C179.012 260.443 178.238 258.494 177.391 256.574L165.382 244.588C165.379 244.59 161.828 248.619 155.115 253.188Z"
        fill="#EBA62F"
      />
      <path
        d="M253.215 291.512C249.294 291.512 241.985 287.935 241.327 287.87C235.737 287.334 241.128 281.834 241.128 281.834C241.128 281.834 249.914 279.903 251.388 280.017C251.87 280.055 252.668 280.215 253.532 280.427L252.588 282.68C252.588 282.68 258.71 283.612 258.787 285.313C258.867 287.021 255.14 291.512 253.215 291.512Z"
        fill="#ABAFBF"
      />
      <path
        d="M242.852 284.557C244.199 280.665 242.323 279.449 242.323 279.449C242.323 279.449 203.962 261.256 200.824 259.253C197.685 257.25 176.596 218.84 176.596 218.84C176.596 218.84 168.778 203.135 158.821 203.45C150.17 203.724 145.361 209.118 142.693 214.773C139.513 221.512 140.855 229.518 145.973 234.933C157.458 247.089 180.527 271.159 186.504 274.811C199.807 282.944 239.665 289.52 239.665 289.52C239.665 289.52 241.794 287.615 242.852 284.557Z"
        fill="#FFEC85"
      />
      <path
        d="M524.159 184.54L518.966 171.431C518.485 170.219 519.084 168.832 520.296 168.352L520.36 168.326C521.573 167.846 522.96 168.444 523.44 169.656L528.633 182.763C529.113 183.975 528.515 185.362 527.303 185.842L527.239 185.868C526.026 186.354 524.639 185.755 524.159 184.54Z"
        fill="#EBA62F"
      />
      <path
        d="M509.766 165.3L525.939 158.89C527.272 158.361 528.795 159.021 529.324 160.354L530.801 164.08C531.33 165.413 530.67 166.937 529.337 167.466L513.161 173.874C511.828 174.403 510.305 173.743 509.776 172.41L508.299 168.683C507.775 167.353 508.433 165.83 509.766 165.3Z"
        fill="#EBA62F"
      />
      <path
        d="M509.022 170.544L530.044 162.214L525.787 151.469L504.764 159.799L509.022 170.544Z"
        fill="#CFD2E0"
      />
      <path
        d="M505.928 162.465C505.928 162.465 508.191 163.192 510.831 161.361C513.472 159.529 512.231 158.073 515.411 158.559C518.591 159.044 521.339 157.642 521.822 156.35C522.307 155.058 527.372 155.325 527.372 155.325L525.808 151.475L504.785 159.804L505.928 162.465Z"
        fill="#F7F8FC"
      />
      <path
        d="M526.995 183.475C527.121 183.793 526.964 184.155 526.645 184.281C526.327 184.407 525.965 184.25 525.839 183.932C525.713 183.613 525.87 183.251 526.188 183.125C526.507 182.999 526.869 183.156 526.995 183.475Z"
        fill="#FFF3B3"
      />
      <path
        d="M518.172 122.344C518.172 122.344 514.661 115.05 511.81 112.785C508.959 110.519 501.354 111.072 501.061 111.652C500.157 113.445 507.166 116.239 507.975 117.886C508.784 119.532 505.425 119.368 508.004 122.226C510.182 124.643 515.396 126.947 515.396 126.947L518.172 122.344Z"
        fill="#ABAFBF"
      />
      <path
        d="M515.136 121.509C516.983 118.635 517.535 118.486 517.535 118.486C517.535 118.486 548.076 130.668 550.991 131.685C553.906 132.702 597.479 135.263 597.479 135.263L610.629 164.165C610.629 164.165 552.563 150.923 545.227 148.2C533.107 143.703 513.667 126.084 513.667 126.084C513.667 126.084 513.687 123.767 515.136 121.509Z"
        fill="#FED647"
      />
      <path
        d="M591.007 391.757C591.007 391.757 590.342 402.478 588.351 405H557.718C557.91 403.932 558.779 401.291 562.608 400.623C567.449 399.781 575.55 396.38 578.481 389.983C581.565 383.251 591.007 391.757 591.007 391.757Z"
        fill="#373B49"
      />
      <path
        d="M645.37 390.262C645.37 390.262 647.278 404.188 644.656 404.427C644.306 404.458 633.005 404.453 628.583 404.427C623.073 404.396 614.277 404.46 614.277 404.46C613.139 404.506 612.394 403.274 612.972 402.295C613.609 401.219 614.821 400.071 617.133 399.624C621.956 398.694 629.995 395.152 632.815 388.706C635.782 381.922 645.37 390.262 645.37 390.262Z"
        fill="#373B49"
      />
      <path
        d="M576.603 249.085C576.603 249.085 584.306 276.037 606.381 322.844C628.457 369.651 630.162 390.979 630.162 390.979L645.37 390.262C645.37 390.262 643.939 334.551 633.511 310.932C623.084 287.313 620.96 222.676 620.96 222.676L576.603 249.085Z"
        fill="#EBA62F"
      />
      <path
        d="M564.236 225.892C564.236 225.892 563.622 267.628 570.845 318.871C578.064 370.116 575.617 391.867 575.617 391.867L592.912 392.443C592.912 392.443 603.248 341.18 600.284 315.532C597.32 289.884 614.436 227.52 614.436 227.52L564.236 225.892Z"
        fill="#FFC425"
      />
      <path
        d="M598.363 128.226L590.206 134.267L578.417 131.786C578.581 130.709 579.359 126.256 580.066 122.218C580.109 121.979 580.15 121.743 580.191 121.509C580.798 118.075 581.324 115.124 581.324 115.124L592.335 109.636L596.439 107.589C596.429 107.661 596.121 111.4 596.077 111.945C595.309 121.64 598.363 128.226 598.363 128.226Z"
        fill="#ABAFBF"
      />
      <path
        d="M579.243 125.177C579.503 125.069 595.281 120.413 596.994 120.978C598.707 121.543 599.721 124.861 599.721 124.861L575.363 131.801C575.363 131.799 575.946 126.567 579.243 125.177Z"
        fill="#FED647"
      />
      <path
        d="M621.727 231.044C619.056 243.244 563.296 204.962 564.041 197.516C564.123 196.7 564.205 195.875 564.287 195.058C565.315 184.692 566.304 174.55 566.373 167.928C566.427 162.185 567.218 156.314 568.274 150.982C569.242 146.058 570.434 141.589 571.469 138.109C572.198 135.656 573.559 133.499 575.365 131.801C576.647 130.596 578.152 129.628 579.813 128.968C580.263 128.778 580.725 128.621 581.195 128.485C587.912 126.538 597.202 124.127 599.724 124.861C606.548 126.87 611.615 138.88 615.206 154.192C621.92 182.853 623.471 223.095 621.727 231.044Z"
        fill="#FFEC85"
      />
      <path
        d="M595.252 112.12C592.835 116.745 583.825 120.747 580.068 122.218C580.112 121.98 580.153 121.743 580.194 121.51C580.8 118.076 581.326 115.125 581.326 115.125L592.337 109.636C594.769 109.6 596.251 110.216 595.252 112.12Z"
        fill="#878C9D"
      />
      <path
        d="M575.974 114.482C575.974 114.482 595.838 120.68 599.506 108.249C603.173 95.8177 608.21 88.2461 595.681 83.7642C583.153 79.2823 579.277 83.2942 577.045 87.1468C574.811 90.9968 570.901 112.548 575.974 114.482Z"
        fill="#ABAFBF"
      />
      <path
        d="M577.825 85.9499C577.825 85.9499 579.092 100.415 582.084 99.7859C585.076 99.1592 587.788 98.6918 587.349 103.053C586.91 107.414 582.762 112.448 591.983 113.219C601.201 113.989 614.453 90.216 611.921 85.7136C604.614 72.7252 567.264 70.1028 577.825 85.9499Z"
        fill="#373B49"
      />
      <path
        d="M565.724 225.892C571.246 227.888 565.629 220.403 565.724 218.844C566.153 211.984 563.464 203.313 564.285 195.058L598.011 174.899C598.014 174.899 606.014 225.574 565.724 225.892Z"
        fill="#FED647"
      />
      <path
        d="M621.728 231.044C607.329 257.727 605.038 267.916 605.038 267.916C592.507 266.488 571.035 241.852 564.223 235.277C564.223 235.277 563.299 204.962 564.041 197.516L574.448 197.216C574.448 197.216 593.262 201.985 598.139 195.513C603.017 189.043 600.905 157.28 600.905 157.28L615.204 154.187C621.92 182.853 625.593 223.883 621.728 231.044Z"
        fill="#FFC425"
      />
      <path
        d="M536.3 179.912C536.3 179.912 529.447 175.276 528.145 174.873C526.846 174.47 526.083 172.456 525.862 172.138C525.081 171.013 524.701 173.021 525.05 173.766C525.454 174.629 526.042 175.862 524.139 175.587C523.774 175.533 520.664 175.459 520.016 176.889C519.369 178.317 518.801 183.213 522.089 184.697C525.377 186.182 533.49 184.841 534.076 185.011C539.038 186.446 536.3 179.912 536.3 179.912Z"
        fill="#ABAFBF"
      />
      <path
        d="M536.236 178.659C536.236 178.659 569.684 184.345 572.651 182.902C577.382 180.598 570.814 146.662 570.814 146.662C570.814 146.662 570.532 138.969 579.516 137.156C587.324 135.579 594.854 141.427 594.854 141.427C594.854 141.427 601.704 147.558 600.831 154.357C598.892 169.428 595.874 200.079 585.793 204.777C572.792 210.836 535.17 187.972 535.17 187.972C535.17 187.972 533.916 186.439 534.096 183.59C534.253 181.076 536.236 178.659 536.236 178.659Z"
        fill="#FFEC85"
      />
      <path
        d="M603.677 156.681L600.905 157.28C600.905 157.28 595.047 131.919 575.363 131.799C576.644 130.594 578.149 129.626 579.811 128.966C587.023 130.9 599.549 137.064 603.677 156.681Z"
        fill="#FFC425"
      />
      <path
        d="M515.57 115.019L503.961 121.917C502.888 122.554 501.508 122.236 500.897 121.206L500.864 121.152C500.252 120.122 500.63 118.758 501.704 118.119L513.313 111.22C514.386 110.583 515.766 110.902 516.377 111.932L516.41 111.985C517.024 113.015 516.644 114.379 515.57 115.019Z"
        fill="#EBA62F"
      />
      <path
        d="M503.193 137.667L487.503 111.261C486.521 109.61 487.069 107.457 488.72 106.476L490.31 105.531C491.961 104.55 494.116 105.097 495.097 106.749L510.788 133.154C511.769 134.806 511.222 136.958 509.57 137.939L507.981 138.884C506.329 139.868 504.174 139.319 503.193 137.667Z"
        fill="#EBA62F"
      />
      <path
        d="M508.774 138.412L499.258 144.07L480 111.657L481.96 110.493L489.514 106.004L508.774 138.412Z"
        fill="#CFD2E0"
      />
      <path
        d="M501.968 142.339L499.258 144.068L480 111.657L481.96 110.493C483.093 111.308 488.142 115.178 488.525 119.388C488.954 124.129 494.774 127.309 494.936 129.813C495.098 132.317 494.936 135.954 498.008 137.007C501.077 138.058 501.968 142.339 501.968 142.339Z"
        fill="#F7F8FC"
      />
      <path
        d="M514.181 112.582C514.463 112.415 514.828 112.507 514.998 112.79C515.164 113.072 515.072 113.437 514.789 113.606C514.507 113.773 514.142 113.681 513.973 113.398C513.806 113.116 513.898 112.749 514.181 112.582Z"
        fill="#FFF3B3"
      />
      <path
        d="M510.567 120.225C510.531 120.192 509.021 118.373 507.534 116.609C506.44 115.312 505.762 113.63 505.284 113.129C504.156 111.945 503.198 114.616 504.868 117.988C506.28 120.844 508.908 123.176 509.822 123.803C510.737 124.427 510.567 120.225 510.567 120.225Z"
        fill="#ABAFBF"
      />
    </SvgIcon>
  );
};

export default MaintenanceLogo;
